var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12 col-sm-6 col-sm-offset-3"},[(_vm.hasFields)?_c('entry-form',{attrs:{"disableCreateAnother":true,"fields":_vm.fields,"form-fields-reset-prop":_vm.formFieldsReset,"in-sidebar":true,"shouldRouterPush":false,"vuexModule":_vm.assetsManager.moduleName}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }